import { useAuth } from '@/hooks/useAuth';
import { Button } from '@/components/ui/button';
import { LogOut, User } from 'lucide-react';

export function Header() {
  const { user, logout, isAuthenticated } = useAuth();

  return (
    <header className="sticky top-0 z-40 w-full border-b bg-white">
      <div className="container flex h-16 items-center justify-between px-4 md:px-6">
        <div className="flex items-center gap-4">
          <a href="/" className="flex items-center gap-3">
            <img src="/Abby_Logo.png" alt="Abby Connect" className="h-10" />
            <span className="text-lg font-semibold text-gray-900">
              Reseller Portal
            </span>
          </a>
        </div>

        {isAuthenticated && user && (
          <div className="flex items-center gap-2 sm:gap-4 min-w-0">
            <div className="hidden sm:flex items-center gap-2 text-sm text-gray-600 min-w-0">
              <User className="h-4 w-4 flex-shrink-0" />
              <span className="truncate max-w-[150px]">{user.email}</span>
              <span className="rounded-full bg-abby-primary/10 px-2 py-0.5 text-xs font-medium text-abby-primary capitalize flex-shrink-0">
                {user.role}
              </span>
            </div>
            <Button variant="ghost" size="sm" onClick={logout} className="flex-shrink-0">
              <LogOut className="h-4 w-4 sm:mr-2" />
              <span className="hidden sm:inline">Logout</span>
            </Button>
          </div>
        )}
      </div>
    </header>
  );
}
